import React from "react";
import { Award, HeartHandshake, Lightbulb, ShieldCheck, Users } from "lucide-react";

import { Hero, FeaturesGrid, CTASection } from "../Components/sections";
import Seo from "../Components/seo/Seo";

function About() {
  return (
    <div>
      <Seo
        title="About"
        description="Learn about EasyBooks Solutions—our mission, vision, and the values behind our accounting, ERP, e-health, and software delivery work."
      />
      <Hero
        eyebrow="About"
        title="Building simple, customizable systems that teams actually use."
        subtitle="EasyBooks Solutions is a Malawian technology company focused on affordable, secure business systems and services—delivered with strong support and measurable outcomes."
        primaryCta={{ label: "Contact us", to: "/Contact" }}
        secondaryCta={{ label: "See products", to: "/EasyBooks_Accounting" }}
        imageSrc="Assets/AboutUs.jpg"
        imageAlt="About EasyBooks Solutions"
        highlights={[
          "Affordable systems for SMEs and institutions",
          "Customizable to fit your workflows",
          "Award-winning product track record",
          "Local partnership with high standards",
        ]}
      />

      <section className="eb-section">
        <div className="eb-container">
          <div className="grid gap-8 lg:grid-cols-3">
            <div className="eb-card p-6">
              <div className="eb-pill">Vision</div>
              <h2 className="mt-4 text-xl font-semibold tracking-tight text-slate-900">
                Simplify operations through ICT innovation.
              </h2>
              <p className="mt-3 eb-muted">
                To simplify business operations for both corporate and SMEs across Malawi and Africa through ICT innovations.
              </p>
            </div>
            <div className="eb-card p-6">
              <div className="eb-pill">Mission</div>
              <h2 className="mt-4 text-xl font-semibold tracking-tight text-slate-900">
                Provide cutting-edge, customizable systems.
              </h2>
              <p className="mt-3 eb-muted">
                To provide innovative, simple and customizable business systems to corporate and SMEs on local and international markets.
              </p>
            </div>
            <div className="eb-card p-6">
              <div className="eb-pill">Approach</div>
              <h2 className="mt-4 text-xl font-semibold tracking-tight text-slate-900">
                Ship value, then iterate with you.
              </h2>
              <p className="mt-3 eb-muted">
                We focus on adoption and outcomes—clear requirements, fast delivery, training, and ongoing support.
              </p>
            </div>
          </div>
        </div>
      </section>

      <FeaturesGrid
        eyebrow="Core values"
        title="How we work"
        subtitle="We build trust by doing the fundamentals well every time."
        columns={3}
        features={[
          { title: "Innovation", description: "We look for better ways to solve real operational problems.", icon: Lightbulb },
          { title: "Professionalism", description: "Clear communication, reliable delivery, and respect for your time.", icon: Users },
          { title: "Client-centricity", description: "We design for users and adoption—not just features.", icon: HeartHandshake },
          { title: "Integrity", description: "We do what we say we’ll do—transparent and accountable.", icon: ShieldCheck },
          { title: "Excellence", description: "We learn continuously and raise the quality bar.", icon: Award },
        ]}
      />

      <CTASection
        title="Want to work with us?"
        subtitle="Tell us what you’re trying to improve we’ll recommend the best solution path."
        primaryCta={{ label: "Start a conversation", to: "/Contact" }}
        secondaryCta={{ label: "Meet the team", to: "/Team" }}
      />
    </div>
  );
}

export default About;
